import { useRef } from 'react'
import { useParams } from 'react-router-dom'

import type { AgGridReact } from 'ag-grid-react'
import type { ReactElement } from 'react'

import columns from './columns'

import ContentLayout from '~/components/ContentLayout'
import Header from '~/components/Header/Classic'
import Layout from '~/components/Layouts/Layout'
import Section from '~/components/Section'
import TableWrapper from '~/components/Tables/TableWrapper'
import UserCard from '~/components/UserCard'
import ViewTitle from '~/components/ViewTitle'
import useDocumentTitle from '~/hooks/useDocumentTitle'
import { useAppSummary } from '~/providers/AppSummary'
import { useSearchComments } from '~/queries/reports'
import { transformByDeviceType } from '~/utils/application'

import './styles.scss'

const ProfilePostComments = (): ReactElement => {
  /** Local state */

  const { postId, profileId } = useParams()

  const { appDetails, appKey, deviceType } = useAppSummary()

  const gridRef = useRef<AgGridReact>(null)

  const tableRef = useRef<HTMLDivElement>(null)

  /** Queries & Mutations */

  const { data: comments, isLoading: isCommentsLoading } = useSearchComments({
    appKey,
    deviceType,
    postId,
    profileId,
  })

  /** Effects */

  useDocumentTitle('Profiles - Post - Comments')

  /** Render */

  const { profile_picture_id, username } = comments?.length ? comments[0] : { profile_picture_id: '', username: '' }

  const rowData = isCommentsLoading ? undefined : comments === undefined ? undefined : comments || []

  const appSelectorApp = appDetails ? transformByDeviceType(appDetails, deviceType) : undefined

  const isSwitchDisabled = !appDetails?.android || !appDetails?.ios

  return (
    <>
      <Header apps={appSelectorApp ? [appSelectorApp] : []} isSwitchDisabled={isSwitchDisabled} />
      <Layout className="comments-view" withPadding>
        <ViewTitle className="layout-view-title">
          <div>Profile Post&apos;s comments</div>
          {comments?.length ? <UserCard name={username} picture={profile_picture_id} /> : null}
        </ViewTitle>
        <ContentLayout loading={isCommentsLoading}>
          <Section>
            <TableWrapper
              className="comments-table with-min-height"
              columnDefs={columns}
              entriesName="profile-comments"
              ref={gridRef}
              rowData={rowData}
              tableRef={tableRef}
              withSearchBar
            />
          </Section>
        </ContentLayout>
      </Layout>
    </>
  )
}
export default ProfilePostComments
